export default [
  {
    name: 'Afghanistan',
    iso2: 'AF',
    phone_code: '+93',
  },
  {
    name: 'Aland Islands',
    iso2: 'AX',
    phone_code: '+358-18',
  },
  {
    name: 'Albania',
    iso2: 'AL',
    phone_code: '+355',
  },
  {
    name: 'Algeria',
    iso2: 'DZ',
    phone_code: '+213',
  },
  {
    name: 'American Samoa',
    iso2: 'AS',
    phone_code: '+1-684',
  },
  {
    name: 'Andorra',
    iso2: 'AD',
    phone_code: '+376',
  },
  {
    name: 'Angola',
    iso2: 'AO',
    phone_code: '+244',
  },
  {
    name: 'Anguilla',
    iso2: 'AI',
    phone_code: '+1-264',
  },
  {
    name: 'Antarctica',
    iso2: 'AQ',
    phone_code: '+672',
  },
  {
    name: 'Antigua and Barbuda',
    iso2: 'AG',
    phone_code: '+1-268',
  },
  {
    name: 'Argentina',
    iso2: 'AR',
    phone_code: '+54',
  },
  {
    name: 'Armenia',
    iso2: 'AM',
    phone_code: '+374',
  },
  {
    name: 'Aruba',
    iso2: 'AW',
    phone_code: '+297',
  },
  {
    name: 'Australia',
    iso2: 'AU',
    phone_code: '+61',
  },
  {
    name: 'Austria',
    iso2: 'AT',
    phone_code: '+43',
  },
  {
    name: 'Azerbaijan',
    iso2: 'AZ',
    phone_code: '+994',
  },
  {
    name: 'Bahrain',
    iso2: 'BH',
    phone_code: '+973',
  },
  {
    name: 'Bangladesh',
    iso2: 'BD',
    phone_code: '+880',
  },
  {
    name: 'Barbados',
    iso2: 'BB',
    phone_code: '+1-246',
  },
  {
    name: 'Belarus',
    iso2: 'BY',
    phone_code: '+375',
  },
  {
    name: 'Belgium',
    iso2: 'BE',
    phone_code: '+32',
  },
  {
    name: 'Belize',
    iso2: 'BZ',
    phone_code: '+501',
  },
  {
    name: 'Benin',
    iso2: 'BJ',
    phone_code: '+229',
  },
  {
    name: 'Bermuda',
    iso2: 'BM',
    phone_code: '+1-441',
  },
  {
    name: 'Bhutan',
    iso2: 'BT',
    phone_code: '+975',
  },
  {
    name: 'Bolivia',
    iso2: 'BO',
    phone_code: '+591',
  },
  {
    name: 'Bonaire, Sint Eustatius and Saba',
    iso2: 'BQ',
    phone_code: '+599',
  },
  {
    name: 'Bosnia and Herzegovina',
    iso2: 'BA',
    phone_code: '+387',
  },
  {
    name: 'Botswana',
    iso2: 'BW',
    phone_code: '+267',
  },
  {
    name: 'Bouvet Island',
    iso2: 'BV',
    phone_code: '+0055',
  },
  {
    name: 'Brazil',
    iso2: 'BR',
    phone_code: '+55',
  },
  {
    name: 'British Indian Ocean Territory',
    iso2: 'IO',
    phone_code: '+246',
  },
  {
    name: 'Brunei',
    iso2: 'BN',
    phone_code: '+673',
  },
  {
    name: 'Bulgaria',
    iso2: 'BG',
    phone_code: '+359',
  },
  {
    name: 'Burkina Faso',
    iso2: 'BF',
    phone_code: '+226',
  },
  {
    name: 'Burundi',
    iso2: 'BI',
    phone_code: '+257',
  },
  {
    name: 'Cambodia',
    iso2: 'KH',
    phone_code: '+855',
  },
  {
    name: 'Cameroon',
    iso2: 'CM',
    phone_code: '+237',
  },
  {
    name: 'Canada',
    iso2: 'CA',
    phone_code: '+1',
  },
  {
    name: 'Cape Verde',
    iso2: 'CV',
    phone_code: '+238',
  },
  {
    name: 'Cayman Islands',
    iso2: 'KY',
    phone_code: '+1-345',
  },
  {
    name: 'Central African Republic',
    iso2: 'CF',
    phone_code: '+236',
  },
  {
    name: 'Chad',
    iso2: 'TD',
    phone_code: '+235',
  },
  {
    name: 'Chile',
    iso2: 'CL',
    phone_code: '+56',
  },
  {
    name: 'China',
    iso2: 'CN',
    phone_code: '+86',
  },
  {
    name: 'Christmas Island',
    iso2: 'CX',
    phone_code: '+61',
  },
  {
    name: 'Cocos (Keeling) Islands',
    iso2: 'CC',
    phone_code: '+61',
  },
  {
    name: 'Colombia',
    iso2: 'CO',
    phone_code: '+57',
  },
  {
    name: 'Comoros',
    iso2: 'KM',
    phone_code: '+269',
  },
  {
    name: 'Congo',
    iso2: 'CG',
    phone_code: '+242',
  },
  {
    name: 'Cook Islands',
    iso2: 'CK',
    phone_code: '+682',
  },
  {
    name: 'Costa Rica',
    iso2: 'CR',
    phone_code: '+506',
  },
  {
    name: "Cote D'Ivoire (Ivory Coast)",
    iso2: 'CI',
    phone_code: '+225',
  },
  {
    name: 'Croatia',
    iso2: 'HR',
    phone_code: '+385',
  },
  {
    name: 'Cuba',
    iso2: 'CU',
    phone_code: '+53',
  },
  {
    name: 'Curaçao',
    iso2: 'CW',
    phone_code: '+599',
  },
  {
    name: 'Cyprus',
    iso2: 'CY',
    phone_code: '+357',
  },
  {
    name: 'Czech Republic',
    iso2: 'CZ',
    phone_code: '+420',
  },
  {
    name: 'Democratic Republic of the Congo',
    iso2: 'CD',
    phone_code: '+243',
  },
  {
    name: 'Denmark',
    iso2: 'DK',
    phone_code: '+45',
  },
  {
    name: 'Djibouti',
    iso2: 'DJ',
    phone_code: '+253',
  },
  {
    name: 'Dominica',
    iso2: 'DM',
    phone_code: '+1-767',
  },
  {
    name: 'Dominican Republic',
    iso2: 'DO',
    phone_code: '+1-809 and 1-829',
  },
  {
    name: 'Ecuador',
    iso2: 'EC',
    phone_code: '+593',
  },
  {
    name: 'Egypt',
    iso2: 'EG',
    phone_code: '+20',
  },
  {
    name: 'El Salvador',
    iso2: 'SV',
    phone_code: '+503',
  },
  {
    name: 'Equatorial Guinea',
    iso2: 'GQ',
    phone_code: '+240',
  },
  {
    name: 'Eritrea',
    iso2: 'ER',
    phone_code: '+291',
  },
  {
    name: 'Estonia',
    iso2: 'EE',
    phone_code: '+372',
  },
  {
    name: 'Eswatini',
    iso2: 'SZ',
    phone_code: '+268',
  },
  {
    name: 'Ethiopia',
    iso2: 'ET',
    phone_code: '+251',
  },
  {
    name: 'Falkland Islands',
    iso2: 'FK',
    phone_code: '+500',
  },
  {
    name: 'Faroe Islands',
    iso2: 'FO',
    phone_code: '+298',
  },
  {
    name: 'Fiji Islands',
    iso2: 'FJ',
    phone_code: '+679',
  },
  {
    name: 'Finland',
    iso2: 'FI',
    phone_code: '+358',
  },
  {
    name: 'France',
    iso2: 'FR',
    phone_code: '+33',
  },
  {
    name: 'French Guiana',
    iso2: 'GF',
    phone_code: '+594',
  },
  {
    name: 'French Polynesia',
    iso2: 'PF',
    phone_code: '+689',
  },
  {
    name: 'French Southern Territories',
    iso2: 'TF',
    phone_code: '+262',
  },
  {
    name: 'Gabon',
    iso2: 'GA',
    phone_code: '+241',
  },
  {
    name: 'Gambia The',
    iso2: 'GM',
    phone_code: '+220',
  },
  {
    name: 'Georgia',
    iso2: 'GE',
    phone_code: '+995',
  },
  {
    name: 'Germany',
    iso2: 'DE',
    phone_code: '+49',
  },
  {
    name: 'Ghana',
    iso2: 'GH',
    phone_code: '+233',
  },
  {
    name: 'Gibraltar',
    iso2: 'GI',
    phone_code: '+350',
  },
  {
    name: 'Greece',
    iso2: 'GR',
    phone_code: '+30',
  },
  {
    name: 'Greenland',
    iso2: 'GL',
    phone_code: '+299',
  },
  {
    name: 'Grenada',
    iso2: 'GD',
    phone_code: '+1-473',
  },
  {
    name: 'Guadeloupe',
    iso2: 'GP',
    phone_code: '+590',
  },
  {
    name: 'Guam',
    iso2: 'GU',
    phone_code: '+1-671',
  },
  {
    name: 'Guatemala',
    iso2: 'GT',
    phone_code: '+502',
  },
  {
    name: 'Guernsey and Alderney',
    iso2: 'GG',
    phone_code: '+44-1481',
  },
  {
    name: 'Guinea',
    iso2: 'GN',
    phone_code: '+224',
  },
  {
    name: 'Guinea-Bissau',
    iso2: 'GW',
    phone_code: '+245',
  },
  {
    name: 'Guyana',
    iso2: 'GY',
    phone_code: '+592',
  },
  {
    name: 'Haiti',
    iso2: 'HT',
    phone_code: '+509',
  },
  {
    name: 'Heard Island and McDonald Islands',
    iso2: 'HM',
    phone_code: '+672',
  },
  {
    name: 'Honduras',
    iso2: 'HN',
    phone_code: '+504',
  },
  {
    name: 'Hong Kong S.A.R.',
    iso2: 'HK',
    phone_code: '+852',
  },
  {
    name: 'Hungary',
    iso2: 'HU',
    phone_code: '+36',
  },
  {
    name: 'Iceland',
    iso2: 'IS',
    phone_code: '+354',
  },
  {
    name: 'India',
    iso2: 'IN',
    phone_code: '+91',
  },
  {
    name: 'Indonesia',
    iso2: 'ID',
    phone_code: '+62',
  },
  {
    name: 'Iran',
    iso2: 'IR',
    phone_code: '+98',
  },
  {
    name: 'Iraq',
    iso2: 'IQ',
    phone_code: '+964',
  },
  {
    name: 'Ireland',
    iso2: 'IE',
    phone_code: '+353',
  },
  {
    name: 'Israel',
    iso2: 'IL',
    phone_code: '+972',
  },
  {
    name: 'Italy',
    iso2: 'IT',
    phone_code: '+39',
  },
  {
    name: 'Jamaica',
    iso2: 'JM',
    phone_code: '+1-876',
  },
  {
    name: 'Japan',
    iso2: 'JP',
    phone_code: '+81',
  },
  {
    name: 'Jersey',
    iso2: 'JE',
    phone_code: '+44-1534',
  },
  {
    name: 'Jordan',
    iso2: 'JO',
    phone_code: '+962',
  },
  {
    name: 'Kazakhstan',
    iso2: 'KZ',
    phone_code: '+7',
  },
  {
    name: 'Kenya',
    iso2: 'KE',
    phone_code: '+254',
  },
  {
    name: 'Kiribati',
    iso2: 'KI',
    phone_code: '+686',
  },
  {
    name: 'Kosovo',
    iso2: 'XK',
    phone_code: '+383',
  },
  {
    name: 'Kuwait',
    iso2: 'KW',
    phone_code: '+965',
  },
  {
    name: 'Kyrgyzstan',
    iso2: 'KG',
    phone_code: '+996',
  },
  {
    name: 'Laos',
    iso2: 'LA',
    phone_code: '+856',
  },
  {
    name: 'Latvia',
    iso2: 'LV',
    phone_code: '+371',
  },
  {
    name: 'Lebanon',
    iso2: 'LB',
    phone_code: '+961',
  },
  {
    name: 'Lesotho',
    iso2: 'LS',
    phone_code: '+266',
  },
  {
    name: 'Liberia',
    iso2: 'LR',
    phone_code: '+231',
  },
  {
    name: 'Libya',
    iso2: 'LY',
    phone_code: '+218',
  },
  {
    name: 'Liechtenstein',
    iso2: 'LI',
    phone_code: '+423',
  },
  {
    name: 'Lithuania',
    iso2: 'LT',
    phone_code: '+370',
  },
  {
    name: 'Luxembourg',
    iso2: 'LU',
    phone_code: '+352',
  },
  {
    name: 'Macau S.A.R.',
    iso2: 'MO',
    phone_code: '+853',
  },
  {
    name: 'Madagascar',
    iso2: 'MG',
    phone_code: '+261',
  },
  {
    name: 'Malawi',
    iso2: 'MW',
    phone_code: '+265',
  },
  {
    name: 'Malaysia',
    iso2: 'MY',
    phone_code: '+60',
  },
  {
    name: 'Maldives',
    iso2: 'MV',
    phone_code: '+960',
  },
  {
    name: 'Mali',
    iso2: 'ML',
    phone_code: '+223',
  },
  {
    name: 'Malta',
    iso2: 'MT',
    phone_code: '+356',
  },
  {
    name: 'Man (Isle of)',
    iso2: 'IM',
    phone_code: '+44-1624',
  },
  {
    name: 'Marshall Islands',
    iso2: 'MH',
    phone_code: '+692',
  },
  {
    name: 'Martinique',
    iso2: 'MQ',
    phone_code: '+596',
  },
  {
    name: 'Mauritania',
    iso2: 'MR',
    phone_code: '+222',
  },
  {
    name: 'Mauritius',
    iso2: 'MU',
    phone_code: '+230',
  },
  {
    name: 'Mayotte',
    iso2: 'YT',
    phone_code: '+262',
  },
  {
    name: 'Niger',
    iso2: 'NE',
    phone_code: '+227',
  },
  {
    name: 'Nigeria',
    iso2: 'NG',
    phone_code: '+234',
  },
  {
    name: 'Niue',
    iso2: 'NU',
    phone_code: '+683',
  },
  {
    name: 'Mexico',
    iso2: 'MX',
    phone_code: '+52',
  },
  {
    name: 'Micronesia',
    iso2: 'FM',
    phone_code: '+691',
  },
  {
    name: 'Moldova',
    iso2: 'MD',
    phone_code: '+373',
  },
  {
    name: 'Monaco',
    iso2: 'MC',
    phone_code: '+377',
  },
  {
    name: 'Mongolia',
    iso2: 'MN',
    phone_code: '+976',
  },
  {
    name: 'Montenegro',
    iso2: 'ME',
    phone_code: '+382',
  },
  {
    name: 'Montserrat',
    iso2: 'MS',
    phone_code: '+1-664',
  },
  {
    name: 'Morocco',
    iso2: 'MA',
    phone_code: '+212',
  },
  {
    name: 'Mozambique',
    iso2: 'MZ',
    phone_code: '+258',
  },
  {
    name: 'Myanmar',
    iso2: 'MM',
    phone_code: '+95',
  },
  {
    name: 'Namibia',
    iso2: 'NA',
    phone_code: '+264',
  },
  {
    name: 'Nauru',
    iso2: 'NR',
    phone_code: '+674',
  },
  {
    name: 'Nepal',
    iso2: 'NP',
    phone_code: '+977',
  },
  {
    name: 'Netherlands',
    iso2: 'NL',
    phone_code: '+31',
  },
  {
    name: 'New Caledonia',
    iso2: 'NC',
    phone_code: '+687',
  },
  {
    name: 'New Zealand',
    iso2: 'NZ',
    phone_code: '+64',
  },
  {
    name: 'Nicaragua',
    iso2: 'NI',
    phone_code: '+505',
  },
  {
    name: 'Norfolk Island',
    iso2: 'NF',
    phone_code: '+672',
  },
  {
    name: 'North Korea',
    iso2: 'KP',
    phone_code: '+850',
  },
  {
    name: 'North Macedonia',
    iso2: 'MK',
    phone_code: '+389',
  },
  {
    name: 'Northern Mariana Islands',
    iso2: 'MP',
    phone_code: '+1-670',
  },
  {
    name: 'Norway',
    iso2: 'NO',
    phone_code: '+47',
  },
  {
    name: 'Oman',
    iso2: 'OM',
    phone_code: '+968',
  },
  {
    name: 'Pakistan',
    iso2: 'PK',
    phone_code: '+92',
  },
  {
    name: 'Palau',
    iso2: 'PW',
    phone_code: '+680',
  },
  {
    name: 'Palestinian Territory Occupied',
    iso2: 'PS',
    phone_code: '+970',
  },
  {
    name: 'Panama',
    iso2: 'PA',
    phone_code: '+507',
  },
  {
    name: 'Papua New Guinea',
    iso2: 'PG',
    phone_code: '+675',
  },
  {
    name: 'Paraguay',
    iso2: 'PY',
    phone_code: '+595',
  },
  {
    name: 'Peru',
    iso2: 'PE',
    phone_code: '+51',
  },
  {
    name: 'Philippines',
    iso2: 'PH',
    phone_code: '+63',
  },
  {
    name: 'Pitcairn Island',
    iso2: 'PN',
    phone_code: '+870',
  },
  {
    name: 'Poland',
    iso2: 'PL',
    phone_code: '+48',
  },
  {
    name: 'Portugal',
    iso2: 'PT',
    phone_code: '+351',
  },
  {
    name: 'Puerto Rico',
    iso2: 'PR',
    phone_code: '+1-787 and 1-939',
  },
  {
    name: 'Qatar',
    iso2: 'QA',
    phone_code: '+974',
  },
  {
    name: 'Reunion',
    iso2: 'RE',
    phone_code: '+262',
  },
  {
    name: 'Romania',
    iso2: 'RO',
    phone_code: '+40',
  },
  {
    name: 'Russia',
    iso2: 'RU',
    phone_code: '+7',
  },
  {
    name: 'Rwanda',
    iso2: 'RW',
    phone_code: '+250',
  },
  {
    name: 'Saint Helena',
    iso2: 'SH',
    phone_code: '+290',
  },
  {
    name: 'Saint Kitts and Nevis',
    iso2: 'KN',
    phone_code: '+1-869',
  },
  {
    name: 'Saint Lucia',
    iso2: 'LC',
    phone_code: '+1-758',
  },
  {
    name: 'Saint Pierre and Miquelon',
    iso2: 'PM',
    phone_code: '+508',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    iso2: 'VC',
    phone_code: '+1-784',
  },
  {
    name: 'Saint-Barthelemy',
    iso2: 'BL',
    phone_code: '+590',
  },
  {
    name: 'Saint-Martin (French part)',
    iso2: 'MF',
    phone_code: '+590',
  },
  {
    name: 'Samoa',
    iso2: 'WS',
    phone_code: '+685',
  },
  {
    name: 'San Marino',
    iso2: 'SM',
    phone_code: '+378',
  },
  {
    name: 'Sao Tome and Principe',
    iso2: 'ST',
    phone_code: '+239',
  },
  {
    name: 'Saudi Arabia',
    iso2: 'SA',
    phone_code: '+966',
  },
  {
    name: 'Senegal',
    iso2: 'SN',
    phone_code: '+221',
  },
  {
    name: 'Serbia',
    iso2: 'RS',
    phone_code: '+381',
  },
  {
    name: 'Seychelles',
    iso2: 'SC',
    phone_code: '+248',
  },
  {
    name: 'Sierra Leone',
    iso2: 'SL',
    phone_code: '+232',
  },
  {
    name: 'Singapore',
    iso2: 'SG',
    phone_code: '+65',
  },
  {
    name: 'Sint Maarten (Dutch part)',
    iso2: 'SX',
    phone_code: '+1721',
  },
  {
    name: 'Slovakia',
    iso2: 'SK',
    phone_code: '+421',
  },
  {
    name: 'Slovenia',
    iso2: 'SI',
    phone_code: '+386',
  },
  {
    name: 'Solomon Islands',
    iso2: 'SB',
    phone_code: '+677',
  },
  {
    name: 'Somalia',
    iso2: 'SO',
    phone_code: '+252',
  },
  {
    name: 'South Africa',
    iso2: 'ZA',
    phone_code: '+27',
  },
  {
    name: 'South Georgia',
    iso2: 'GS',
    phone_code: '+500',
  },
  {
    name: 'South Korea',
    iso2: 'KR',
    phone_code: '+82',
  },
  {
    name: 'South Sudan',
    iso2: 'SS',
    phone_code: '+211',
  },
  {
    name: 'Spain',
    iso2: 'ES',
    phone_code: '+34',
  },
  {
    name: 'Sri Lanka',
    iso2: 'LK',
    phone_code: '+94',
  },
  {
    name: 'Sudan',
    iso2: 'SD',
    phone_code: '+249',
  },
  {
    name: 'Suriname',
    iso2: 'SR',
    phone_code: '+597',
  },
  {
    name: 'Svalbard and Jan Mayen Islands',
    iso2: 'SJ',
    phone_code: '+47',
  },
  {
    name: 'Sweden',
    iso2: 'SE',
    phone_code: '+46',
  },
  {
    name: 'Switzerland',
    iso2: 'CH',
    phone_code: '+41',
  },
  {
    name: 'Syria',
    iso2: 'SY',
    phone_code: '+963',
  },
  {
    name: 'Taiwan',
    iso2: 'TW',
    phone_code: '+886',
  },
  {
    name: 'Tajikistan',
    iso2: 'TJ',
    phone_code: '+992',
  },
  {
    name: 'Tanzania',
    iso2: 'TZ',
    phone_code: '+255',
  },
  {
    name: 'Thailand',
    iso2: 'TH',
    phone_code: '+66',
  },
  {
    name: 'The Bahamas',
    iso2: 'BS',
    phone_code: '+1-242',
  },
  {
    name: 'Timor-Leste',
    iso2: 'TL',
    phone_code: '+670',
  },
  {
    name: 'Togo',
    iso2: 'TG',
    phone_code: '+228',
  },
  {
    name: 'Tokelau',
    iso2: 'TK',
    phone_code: '+690',
  },
  {
    name: 'Tonga',
    iso2: 'TO',
    phone_code: '+676',
  },
  {
    name: 'Trinidad and Tobago',
    iso2: 'TT',
    phone_code: '+1-868',
  },
  {
    name: 'Tunisia',
    iso2: 'TN',
    phone_code: '+216',
  },
  {
    name: 'Turkey',
    iso2: 'TR',
    phone_code: '+90',
  },
  {
    name: 'Turkmenistan',
    iso2: 'TM',
    phone_code: '+993',
  },
  {
    name: 'Turks and Caicos Islands',
    iso2: 'TC',
    phone_code: '+1-649',
  },
  {
    name: 'Tuvalu',
    iso2: 'TV',
    phone_code: '+688',
  },
  {
    name: 'Uganda',
    iso2: 'UG',
    phone_code: '+256',
  },
  {
    name: 'Ukraine',
    iso2: 'UA',
    phone_code: '+380',
  },
  {
    name: 'United Arab Emirates',
    iso2: 'AE',
    phone_code: '+971',
  },
  {
    name: 'United Kingdom',
    iso2: 'GB',
    phone_code: '+44',
  },
  {
    name: 'United States',
    iso2: 'US',
    phone_code: '+1',
  },
  {
    name: 'United States Minor Outlying Islands',
    iso2: 'UM',
    phone_code: '+1',
  },
  {
    name: 'Uruguay',
    iso2: 'UY',
    phone_code: '+598',
  },
  {
    name: 'Uzbekistan',
    iso2: 'UZ',
    phone_code: '+998',
  },
  {
    name: 'Vanuatu',
    iso2: 'VU',
    phone_code: '+678',
  },
  {
    name: 'Vatican City State (Holy See)',
    iso2: 'VA',
    phone_code: '+379',
  },
  {
    name: 'Venezuela',
    iso2: 'VE',
    phone_code: '+58',
  },
  {
    name: 'Vietnam',
    iso2: 'VN',
    phone_code: '+84',
  },
  {
    name: 'Virgin Islands (British)',
    iso2: 'VG',
    phone_code: '+1-284',
  },
  {
    name: 'Virgin Islands (US)',
    iso2: 'VI',
    phone_code: '+1-340',
  },
  {
    name: 'Wallis and Futuna Islands',
    iso2: 'WF',
    phone_code: '+681',
  },
  {
    name: 'Western Sahara',
    iso2: 'EH',
    phone_code: '+212',
  },
  {
    name: 'Yemen',
    iso2: 'YE',
    phone_code: '+967',
  },
  {
    name: 'Zambia',
    iso2: 'ZM',
    phone_code: '+260',
  },
  {
    name: 'Zimbabwe',
    iso2: 'ZW',
    phone_code: '+263',
  },
]
